"use client";
import {
  Carousel,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { Lang } from "@/i18n/settings";
import { AwardCategoriesSectionProps } from "@/services/home/types";
import DesktopCards from "./DesktopCards";
import { MobileCarousel } from "./MobileCarousel";
import { Shell } from "@/components/ui/shell";
import { Fade } from "@/components/ui/animations";

type Props = {
  data: AwardCategoriesSectionProps;
  lang: Lang;
};

export default function Categories({ data, lang }: Readonly<Props>) {
  return (
    <Carousel
      opts={{
        align: "start",
        direction: lang === "ar" ? "rtl" : "ltr",
        loop: true,
      }}
      className="w-full bg-foreground"
    >
      <Shell className="!py-20 lg:flex">
        <div className="flex w-full flex-col gap-20">
          <Fade className="flex w-full items-center justify-between gap-4">
            <h1 className="text-2xl text-secondary md:text-[38px] xl:text-[48px] ltr:font-playfair">
              {data.title}
            </h1>
            <div className="flex items-center gap-4 xl:hidden rtl:flex-row-reverse">
              <CarouselPrevious className="relative h-10 w-10 md:h-12 md:w-12" />
              <CarouselNext className="relative h-10 w-10 md:h-12 md:w-12" />
            </div>
          </Fade>
          <div className="xl:hidden">
            <MobileCarousel data={data.award_categories} />
          </div>
          <div className="hidden flex-col gap-20 xl:flex">
            <DesktopCards data={data.award_categories} />
          </div>
        </div>
      </Shell>
    </Carousel>
  );
}
